import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const CustomSelect = ({ items = [], onChange, value, ...restProps }) => {
    return (
        <Select {...restProps} value={value} onChange={onChange}>
            {items.map((item, index) => (
                <Option key={item.key || item.value || index} value={item.value} label={item.label} disabled={item.disabled}>
                    {item.label}
                </Option>
            ))}
        </Select>
    );
};

export default CustomSelect;